import { ReactNode } from 'react';
import { Controller, Path, useFormContext } from 'react-hook-form';
import { Country, DefaultInputComponentProps } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import ErrorMessage from '../ErrorMessage/ErrorMessage';
import { FormPhoneInputStyled, LabelStyled, RequiredSignStyled } from './FormPhoneInput.styled';

type FormPhoneInputPropsT<FormValuesT> = Omit<
  DefaultInputComponentProps,
  'placeholderText' | 'onChange'
> & {
  name: Path<FormValuesT>;
  placeholder?: string;
  label?: string | ReactNode;
  isRequired?: boolean;
  defaultCountry?: Country;
};

const FormPhoneInput = <FormValuesT,>({
  name,
  placeholder,
  label,
  isRequired = false,
  ...restFormPhoneInputProps
}: FormPhoneInputPropsT<FormValuesT>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      {label && (
        <LabelStyled htmlFor={name}>
          {label}
          {isRequired && <RequiredSignStyled>&nbsp;*</RequiredSignStyled>}
        </LabelStyled>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { ref, value, onChange, ...restFieldProps } }) => (
          <FormPhoneInputStyled
            data-testid="phone-number"
            control={control}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            {...restFieldProps}
            {...restFormPhoneInputProps}
          />
        )}
      />
      {errors[name] && <ErrorMessage error={errors[name]?.message as Path<FormValuesT>} />}
    </>
  );
};

export default FormPhoneInput;
